var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.4286H16.0812L11.54 17.6573C11.0975 18.263 11.17 19.1644 11.7 19.6687C12.2312 20.1744 13.0188 20.0916 13.4613 19.4858L19.7113 10.9144C19.76 10.8472 19.7838 10.7686 19.82 10.6944C19.85 10.6344 19.8863 10.5829 19.9088 10.5172C19.965 10.3529 19.9987 10.1801 19.9987 10.0058L20 10.0001L19.9987 9.99435C19.9987 9.82006 19.965 9.64721 19.9088 9.48292C19.8863 9.4172 19.85 9.36578 19.82 9.30577C19.7838 9.23149 19.76 9.15292 19.7113 9.08577L13.4613 0.514289C13.2125 0.175715 12.8575 0 12.5 0C12.2175 0 11.9338 0.108572 11.7 0.331431C11.17 0.83572 11.0975 1.73715 11.54 2.34287L16.0812 8.57148H1.25C0.56 8.57148 0 9.21149 0 10.0001C0 10.7886 0.56 11.4286 1.25 11.4286Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.730a1d0a9f17f1a05d102787ec06c1e7.svg";
export { ForwardRef as ReactComponent };